/**
 * useMe Hook
 * 
 * React Query hook for fetching and caching the current user's profile.
 * This is the single source of truth for the authenticated user.
 * 
 * Returns null when unauthenticated (guest user) - this is NOT an error state.
 */

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { Me } from '@/lib/api/auth';
import { authApi } from '@/lib/api/auth';

export function useMe(options?: Partial<UseQueryOptions<Me | null>>) {
  return useQuery<Me | null>({
    queryKey: ['me'],
    queryFn: authApi.me,
    retry: false, // Don't retry on auth failures
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options, // Allow overriding any query options
  });
}
